import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import AbstractDetector from "./AbstractDetector";
/**
 * The UrlDetector parses the url and looks for language related attributes.
 */
var UrlDetector = /** @class */ (function (_super) {
    __extends(UrlDetector, _super);
    function UrlDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The regex used to identify url language parameters.
         *
         * Examples:
         * + /nl/
         * + /nl-BE/
         * + /nl_nl/
         * + /nl_NL/
         */
        _this.regex = /(?:\/)([a-zA-Z]{2})((?:-|_|:\/|\?.*|\/\??.*|$)[a-zA-z]{2})?\//;
        /**
         * The lowercase formatted query string.
         */
        _this.search = window.location.search.toLowerCase();
        return _this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    UrlDetector.prototype.detect = function () {
        var matches = this.search.match(this.regex);
        var language = null;
        if (matches) {
            language = matches[1];
        }
        return _super.prototype.detect.call(this, language);
    };
    UrlDetector.prototype.getName = function () {
        return LanguageDetectorNames.Url;
    };
    return UrlDetector;
}(AbstractDetector));
export default UrlDetector;
//# sourceMappingURL=UrlDetector.js.map